import { querySelectorAll } from '../helpers'

export function initializeSearchform() {
  const updateAction = (form: HTMLFormElement, page: string) => {
    form.action = `/${page}`
  }

  querySelectorAll<HTMLFormElement>('form.searchform').forEach(form => {
    querySelectorAll<HTMLInputElement>('input[name="source"]', form).forEach(
      input => {
        if (input.checked) {
          updateAction(form, input.value)
        }

        input.addEventListener('change', e => {
          updateAction(form, input.value)
        })
      }
    )
  })
}
